import React from "react";
import {
  StepCard,
  StepTitle,
  StepSubtitle,
  FormGroup,
  SelectableCardsGrid,
  SelectableCard,
  NavigationButtonsRow,
  ActionButton,
} from "../registerStyles";

const ROLES_USUARIO = [
  {
    id: "ODONTOLOGO_DUENO",
    icon: "👨‍⚕️",
    title: "Odontólogo dueño",
    desc: "Soy dueño(a) y atiendo pacientes",
  },
  {
    id: "ADMINISTRADOR",
    icon: "📋",
    title: "Administrador(a)",
    desc: "Gestiono las operaciones y finanzas",
  },
  {
    id: "ASISTENTE",
    icon: "👩‍💼",
    title: "Asistente / Recepción",
    desc: "Agendo citas y recibo pacientes",
  },
  {
    id: "OTRO",
    icon: "🤝",
    title: "Otro profesional",
    desc: "Especialista, socio o en formación",
  },
];

export const StepClinicRole = ({
  formData,
  setFormData,
  onNext,
  onBack,
}) => {
  const isSelected = Boolean(formData.rolUsuario);

  return (
    <StepCard>
      <StepTitle>¿Cuál es tu rol principal?</StepTitle>
      <StepSubtitle>
        Personalizaremos tu experiencia según tu función en el consultorio.
      </StepSubtitle>

      <FormGroup>
        <SelectableCardsGrid columns={2}>
          {ROLES_USUARIO.map((rol) => {
            const selected = formData.rolUsuario === rol.id;
            return (
              <SelectableCard
                key={rol.id}
                selected={selected}
                horizontal
                onClick={() => {
                  setFormData({ ...formData, rolUsuario: rol.id });
                  onNext("rolUsuario", rol.id);
                }}
              >
                <div className="icon-wrapper" style={{ fontSize: "1.4rem" }}>
                  {rol.icon}
                </div>
                <div>
                  <h4 className="card-title">{rol.title}</h4>
                  <p className="card-description">{rol.desc}</p>
                </div>
              </SelectableCard>
            );
          })}
        </SelectableCardsGrid>
      </FormGroup>

      <NavigationButtonsRow>
        <ActionButton type="button" onClick={onBack}>
          ← Atrás
        </ActionButton>
      </NavigationButtonsRow>
    </StepCard>
  );
};
